module.exports = __webpack_public_path__ + "static/img/home-img10.745467a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img10.png
// module id = dMbC
// module chunks = 1